import React, { useCallback } from 'react';
import { EDTextEdit } from '../TextEdit/EDTextEdit';
import EDIcon from '../Icon/EDIcon';
import EDBox from '../EDBox/EDBox';
import AvenyTheme from '../ThemeProvider/AvenyTheme';

interface IProps {
  value: string;
  onChange: (value: string | React.ChangeEvent<HTMLInputElement>) => void;
  autoFocus?: boolean;
  placeholder?: string;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
}
//Används framförallt i MainMenu
export const EDSearchBar: React.FC<React.PropsWithChildren<IProps>> = ({
  value = '',
  onChange,
  autoFocus = false,
  placeholder = '',
  onFocus,
  ...props
}) => {
  if (!onChange) {
    onChange = () => {};
  }

  const handleChange = useCallback(
    (value: string | React.ChangeEvent<HTMLInputElement>) => {
      if (typeof value === 'string') {
        onChange(value);
      } else if (value?.currentTarget) {
        onChange(value.currentTarget.value);
      }
    },
    [onChange]
  );

  return (
    <EDBox
      sx={{
        color: AvenyTheme.palette.text.primary,
        padding: theme => theme.spacing(0.75),
        '& .MuiFormControl-root': {
          margin: theme => theme.spacing(0),
          color: AvenyTheme.palette.text.primary,
          backgroundColor: AvenyTheme.palette.background.paper,
          borderRadius: theme => theme.spacing(0.5),
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
          {
            border: 'none',
          },
      }}
    >
      <EDTextEdit
        onFocus={onFocus}
        autoFocus={autoFocus}
        placeholder={placeholder}
        value={value ?? ''}
        onChange={handleChange}
        startAdornment={
          <EDIcon iconType="search" color="secondary" size="medium" />
        }
      />
    </EDBox>
  );
};

export default EDSearchBar;
